import React, { useContext, useEffect, useState } from 'react';
import '../createSurvey.css';
import Navbar from '../../../components/navbar/Navbar';
import Steps from '../../../components/steps';

import Select from 'react-select';
import {
  Button,
  CircularProgress,
  Dialog,
  Grid,
  IconButton,
  TextField,
} from '@mui/material';
import Footer from '../../../components/navbar/Footer';
import { useLocation, useNavigate } from 'react-router-dom';
import { StepsContext } from '../../../context/stepsContext';
import axios from 'axios';
import { faCoins } from '@fortawesome/free-solid-svg-icons';
import { faSmile } from '@fortawesome/free-solid-svg-icons';
import { faRunning } from '@fortawesome/free-solid-svg-icons';
import { faBrain } from '@fortawesome/free-solid-svg-icons';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { faHandshakeSimple } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Toast from '../../../components/toast/Toast';
import Result from './Result';
import Invite from '../../../components/invite';
import Snack from '../../../components/snack';
import { REACT_APP_SURVEY_ID, REACT_APP_SURVEY_ID_ER } from '../../../config';
import man from '../../../assets/images/man.png';
import details from '../../../assets/images/details.jpg';
import woman from '../../../assets/images/woman.png';
import none from '../../../assets/images/none.png';
import { CancelOutlined } from '@mui/icons-material';

const CustomOptionAge = ({ innerProps, label, data }) => (
  <div
    {...innerProps}
    style={{ display: 'flex', padding: '10px', color: '#000' }}
  >
    {label}
  </div>
);
const CustomOption = ({ innerProps, label, data }) => (
  <div
    {...innerProps}
    style={{
      display: 'flex',
      padding: '10px',
      color: '#000',
    }}
  >
    <img
      src={data.image}
      alt={label}
      style={{ width: '24px', marginRight: '8px' }}
    />
    {data?.label}
  </div>
);

const CustomSingleValueAge = ({ innerProps, label, data }) => (
  <div {...innerProps} style={{ display: 'flex', color: '#000' }}>
    <div style={{ color: '#000' }}>{data.label}</div>
  </div>
);
const CustomSingleValue = ({ innerProps, label, data }) => (
  <div {...innerProps} style={{ display: 'flex', color: '#000' }}>
    <img
      src={data.image}
      alt={label}
      style={{ width: '24px', marginRight: '8px' }}
    />
    <div style={{ color: '#000' }}>{data.label}</div>
  </div>
);
export default function StepThreeTwo({
  minutesDisplay,
  secondsDisplay,
  final,
}) {
  /*eslint-disable */

  const [open, setOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Logic to check if scroll has started
      if (!open && initialId === REACT_APP_SURVEY_ID) {
        setOpen(true);
        window.removeEventListener('scroll', handleScroll);
      }
    };

    // Attach the event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const [openSnack, setOpenSnack] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email1, setEmail1] = useState('');
  const [email2, setEmail2] = useState('');
  const [email3, setEmail3] = useState('');
  const [email1valid, setEmail1valid] = useState('');
  const [email2valid, setEmail2valid] = useState('');
  const [email3valid, setEmail3valid] = useState('');
  const { state: finalStep } = useLocation();
  const { state } = finalStep;
  const { data } = finalStep;
  const { type } = finalStep;
  const { survey_id: initialId } = finalStep;
  const [showDetail, setShowDetail] = useState(false);
  const [selectedAgeIndex, setSelectedAgeIndex] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  console.log('selectedAgeIndex', initialId);
  console.log('selectedAgeIndex', selectedAgeIndex);
  console.log('selectedAgeIndex', selectedOption);
  console.log('type', initialId);
  const member_id = state && state?.member_id;
  const [text, setEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const filteredResources = {};

  if (data?.resources) {
    for (const [key, value] of Object.entries(data?.resources)) {
      const filteredSubResources = value.filter(
        (subResource) => subResource.resource_type === type
      );
      if (filteredSubResources.length > 0) {
        filteredResources[key] = filteredSubResources;
      }
    }
  }
  const handleChange = async (option) => {
    setSelectedOption(option);
  };
  const handleChangeAge = async (option) => {
    setSelectedAgeIndex(option);
  };
  const handleCompanyName = (e) => {
    setCompanyName(() => e.target.value);
  };
  const handleEmail = (e) => {
    setEmail(() => e.target.value);
  };
  const navigate = useNavigate();
  const { start } = useContext(StepsContext);
  useEffect(() => {
    if (!start) navigate('/pageNotfound');
  }, [start, navigate]);
  const newArray = [];

  const [toastState, setToastState] = React.useState({
    open: false,
  });
  const handleCloseToast = () => {
    setToastState({
      open: !toastState.open,
    });
  };

  data?.resources &&
    Object.values(data?.resources).forEach((item) => {
      item.forEach((subItem) => {
        const { title, url } = subItem;
        newArray.push({ title, url });
      });
    });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const survey_id_manage =
    initialId === REACT_APP_SURVEY_ID
      ? REACT_APP_SURVEY_ID
      : REACT_APP_SURVEY_ID_ER;
  const isValid = emailRegex?.test(text);
  console.log('selectedAgeIndex', isValid);
  console.log('selectedAgeIndex', [
    companyName,
    emailRegex?.test(text),
    selectedOption?.label?.length,
    selectedAgeIndex?.label?.length > 0,
  ]);
  const submit = async () => {
    const data =
      survey_id_manage === initialId
        ? {
            project_id: initialId,
            member_id: member_id,
            agegroup: selectedAgeIndex?.label,
            gender: selectedOption?.label,
            email: text,
          }
        : { project_id: initialId, member_id: member_id, email: text };
    setLoading(true);
    await axios({
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/reports/sendIndividualReportLink`,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: data,
    })
      .then(function (response) {
        // console.log(response);
        // console.log(state);
        console.log(response);
        // window.scrollTo(0, document.body.scrollHeight);
        handleCloseToast();
        setLoading(false);

        // window.location.reload();
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const handleClick = async () => {
    navigate('/success', {
      state: {
        state: finalStep,
        survey_id: initialId,
      },
    });
  };
  const handleCloseSnack = () => {
    setOpenSnack(false);
  };

  let selectedResource =
    initialId === survey_id_manage ? filteredResources : data?.resources;

  const options = [
    {
      label: 'Male',
      image: man,
    },
    {
      label: 'Female',
      image: woman,
    },
    {
      label: 'Other',
      image: none,
    },
  ];
  const ages = [
    {
      label: '20-29',
      image: null,
    },
    {
      label: '30-39',
      image: null,
    },
    {
      label: '40-49',
      image: null,
    },
    {
      label: '50+',
      image: null,
    },
  ];

  return (
    <div className="mainContainer" style={{ backgroundColor: '#f2f2f2' }}>
      <Navbar
        special={
          REACT_APP_SURVEY_ID === initialId ||
          REACT_APP_SURVEY_ID_ER === initialId
        }
        minutesDisplay={minutesDisplay}
        secondsDisplay={secondsDisplay}
        hidden
      />

      {/* {pickle && <Pickles />} */}
      <div className="surveys-sub-container">
        <div className="mb-16 text-3xl xs:!w-11/12 xs:text-2xl sm:text-4xl sm:w-full">
          {REACT_APP_SURVEY_ID_ER === initialId
            ? 'Thank you for completing the KAYA survey. Here are your results'
            : 'Thank you for completing the KAYA wellbeing survey. Here are your results'}
        </div>
        {final ? (
          <Result setOpen={setOpen} data={data} setShowDetail={setShowDetail} />
        ) : (
          <Steps er={REACT_APP_SURVEY_ID_ER === initialId} step={33} active />
        )}
        <div className="inst-sub mt-12 !w-full">
          <div
            className="px-16"
            style={{
              gap: '30px',
              fontSize: '18px',
              color: 'red',
              fontWeight: '400',
            }}
          >
            {REACT_APP_SURVEY_ID_ER === initialId
              ? 'The KAYA system has analysed your responses and created the Experience Score and Report for you. You can download a copy of your Employee Experiece Report below.'
              : 'The KAYA system has analysed your responses and created a Wellbeing Score and Report for you. You can download a copy of your Employee Wellbeing Report below.'}
          </div>
          <div
            className="px-16"
            style={{
              gap: '20px',
              fontSize: '20px',
              color: '#000',
              fontWeight: '400',
            }}
          >
            KAYA will now combine your responses with your colleagues to create
            an overall team and/or company score and report.
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '30px',
              backgroundColor: '#fff',
            }}
            className="justify-center p-16"
          >
            <div className="link-sub !text-xl text-center">
              {REACT_APP_SURVEY_ID_ER === initialId
                ? 'To receive your KAYA Experience Report including the links below please add your email address here:'
                : 'To receive your KAYA Wellbeing Report including the links below please add your email address here:'}
            </div>
            <div
              className="sbtop"
              style={{
                display: 'flex',
                widtht: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '50px',
                fontSize: '20px',
              }}
            >
              <div
                className={`dropdown-select ${
                  survey_id_manage === initialId ? '' : 'dropdown-select2'
                } textinput-t flex gap-2`}
                style={{
                  width: survey_id_manage === initialId ? '80%' : '60%',
                }}
              >
                <Grid container spacing={2}>
                  {/* {survey_id_manage === initialId && (
                    <Grid item sm={12} md={6} lg={3} className="w-full">
                      <TextField
                        label="Enter Company Name"
                        fullWidth
                        size="medium"
                        sx={{
                          '& input .internal-autofill-selected ': {
                            backgroundColor: '0 0 0 1000px white inset',
                            color: '#000',
                          },
                        }}
                        onChange={handleCompanyName}
                        style={{
                          flex: 1,
                          color: '#000',
                          fontSize: '18px',
                          fontWeight: '400px',
                        }}
                        variant="outlined"
                      />
                    </Grid>
                  )} */}
                  {survey_id_manage === initialId && (
                    <Grid item sm={12} md={6} lg={4} className="w-full">
                      <Select
                        options={ages}
                        value={selectedAgeIndex}
                        placeholder="Select Age Group"
                        isSearchable={false}
                        onChange={handleChangeAge}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.label}
                        components={{
                          Option: CustomOptionAge,
                          SingleValue: CustomSingleValueAge,
                        }}
                        styles={{
                          valueContainer: (provided) => ({
                            ...provided,
                            display: 'flex',
                            minWidth: '100px',
                            height: '100%',
                            flex: 1,
                            minHeight: '51px',
                          }),
                        }}
                      />
                    </Grid>
                  )}
                  {survey_id_manage === initialId && (
                    <Grid item sm={12} md={6} lg={4} className="w-full">
                      <Select
                        options={options}
                        value={selectedOption}
                        placeholder="Select Gender"
                        isSearchable={false}
                        onChange={handleChange}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.label}
                        components={{
                          Option: CustomOption,
                          SingleValue: CustomSingleValue,
                        }}
                        style={{
                          display: 'flex',
                          minWidth: '100px',
                          height: '100%',
                          flex: 1,
                        }}
                        styles={{
                          valueContainer: (provided) => ({
                            ...provided,
                            display: 'flex !important',
                            minWidth: '100px',
                            height: '100%',
                            flex: 1,
                            minHeight: '51px',
                          }),
                        }}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    sm={12}
                    md={survey_id_manage === initialId ? 6 : 12}
                    lg={survey_id_manage === initialId ? 4 : 12}
                    className="w-full"
                  >
                    <TextField
                      label="Enter your email address"
                      fullWidth
                      size={'medium'}
                      sx={{
                        '& input .internal-autofill-selected ': {
                          backgroundColor: '0 0 0 1000px white inset',
                          color: '#000',
                        },
                        '& .MuiInputLabel-root': {
                          zIndex: 0,
                        },
                      }}
                      onChange={handleEmail}
                      style={{
                        flex: 1,
                        color: '#000',
                        fontSize: '18px',
                        fontWeight: '400px',
                      }}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </div>
              <div
                style={{ display: 'flex', gap: '20px' }}
                className={`btn-container btn-container2 ${
                  survey_id_manage === initialId
                    ? 'btn-container21'
                    : 'btn-container3'
                }`}
              >
                <Button
                  endIcon={loading && <CircularProgress size={'20px'} />}
                  onClick={submit}
                  className="signupCVbtnSign w-max flex self-end"
                  type="submit"
                  variant="contained"
                  style={{
                    backgroundColor: !isValid ? '' : '#D0ECE6',
                    color: '#000',
                  }}
                  disabled={!isValid}
                  sx={{
                    fontSize: '16px',
                    fontWeight: 500,
                    padding: '8px 30px',
                    textTransform: 'capitalize',
                    color: '#000',
                    backgroundColor: '#D0ECE6',
                    '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                      backgroundColor: !isValid ? '' : '#D0ECE6',
                    },
                  }}
                >
                  Send Report
                </Button>
                {initialId === REACT_APP_SURVEY_ID && (
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!isValid}
                    className="signupCVbtnSign2 mt-6 mb-4 w-max flex self-end"
                    style={{
                      backgroundColor: !isValid ? '' : '#D0ECE6',
                      color: '#000',
                    }}
                    onClick={() => setOpen(true)}
                    sx={{
                      fontSize: '16px',
                      fontWeight: 500,
                      padding: '8px 30px',
                      textTransform: 'capitalize',
                      color: '#000',
                      backgroundColor: '#D0ECE6',
                      '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                        backgroundColor: !isValid ? '' : '#D0ECE6',
                      },
                    }}
                  >
                    Refer your friends
                  </Button>
                )}
              </div>
            </div>
          </div>
          <div
            className="text-center"
            style={{ fontWeight: 500, fontSize: '28px', marginTop: '30px' }}
          >
            Your Wellbeing Resources
          </div>
          <div
            className="text-center"
            style={{ color: 'red', fontSize: '18px', fontWeight: '400' }}
          >
            Here are a selection of videos, quizzes, articles and podcasts to
            support your wellbeing journey.
          </div>
          <div
            className="p-4"
            style={{
              fontSize: '1.5rem',
              color: 'lightgray',
              fontWeight: 600,
              marginTop: '30px',
              display: 'flex',
              textAlign: 'center',
            }}
          >
            <div
              className="header-1 header-12"
              style={{
                display: 'flex',
                flex: '2',
                textAlign: 'center',
                justifyContent: 'center',
              }}
            >
              Initiative
            </div>
            <div
              className="header-1"
              style={{
                display: 'flex',
                flex: '2',
                justifyContent: 'center',
                fontWeight: 500,
                fontSize: '28px',
                color: 'lightgray',
                textAlign: 'center',
              }}
            >
              Wellbeing Area
            </div>
            <div
              className="header-1"
              style={{
                display: 'flex',
                flex: '3',
                justifyContent: 'center',
                textAlign: 'center',
                fontWeight: 500,
                fontSize: '28px',
                color: 'lightgray',
              }}
            >
              Resources
            </div>
          </div>
          {data?.resources && (
            <div className="resource-initiatives-container">
              {Object.keys(data?.resources) &&
                Object.keys(data?.resources)?.map((key, _) => (
                  <div className="initiatives-item p-4" key={_}>
                    <div className="initiatives-left initiatives-item-key">
                      {key}
                    </div>
                    <div className="initiatives-left initiatives-left-icon">
                      {/* {data?.resources[`${key}`][0]?.area} */}
                      <FontAwesomeIcon
                        icon={
                          data?.resources?.length > 0 &&
                          data?.resources[`${key}`][0]?.area === 'mental'
                            ? faBrain
                            : data?.resources[`${key}`][0]?.area === 'financial'
                            ? faCoins
                            : data?.resources[`${key}`][0]?.area === 'social'
                            ? faSmile
                            : data?.resources[`${key}`][0]?.area === 'societal'
                            ? faUsers
                            : data?.resources[`${key}`][0]?.area === 'physical'
                            ? faRunning
                            : faHandshakeSimple
                        }
                        color={'#0c7c90'}
                        // style={{ backgroundColor:`${props.selectedArea === props.item ? '#2691a3' : ''}`}}
                        size="2x"
                      />
                      {/* <AccessAlarmsIcon /> */}
                    </div>
                    <ul className="initiatives-right">
                      {data?.resources[key]?.slice(0, 3)?.map((item, _) => (
                        <li key={_}>
                          <a
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
            </div>
          )}
        </div>
        <div className="btn-container" id="next-btn">
          {/* <Link to={'/steptwo'}> */}
          <Button
            // disabled={Altered}
            onClick={handleClick}
            className="signupCVbtnSign"
            variant="contained"
            style={{
              backgroundColor: '#2691a3',
            }}
            sx={{
              fontSize: '16px',
              fontWeight: 500,
              padding: '8px 30px',
              textTransform: 'capitalize',
              backgroundColor: '#2691a3',
              '&.css-ke7xld-MuiButtonBase-root-MuiButton-root:hover': {
                backgroundColor: '#2691a3',
              },
            }}
          >
            Next
          </Button>
          {/* </Link> */}
        </div>
        <Toast
          password
          handleClose={handleCloseToast}
          state={toastState}
          error="A copy of the report has been emailed to you."
        />
        <Invite
          loading={loading}
          setLoading={setLoading}
          open={open}
          setOpen={setOpen}
          setOpenSnack={setOpenSnack}
          project_id={initialId}
          member_id={member_id}
          email={text}
          email1={email1}
          email2={email2}
          email3={email3}
          email1valid={email1valid}
          email2valid={email2valid}
          email3valid={email3valid}
          setEmail1={setEmail1}
          setEmail2={setEmail2}
          setEmail3={setEmail3}
          setEmail1valid={setEmail1valid}
          setEmail2valid={setEmail2valid}
          setEmail3valid={setEmail3valid}
          agegroup={selectedAgeIndex?.label}
          gender={selectedOption?.label}
          company_name={companyName}
        />
        <Snack
          open={openSnack}
          color={'success'}
          onClose={handleCloseSnack}
          message="Invitation sent successfully"
        />
        <Dialog
          fullWidth
          sx={{
            '& .MuiPaper-root': {
              minWidth: '80vw',
              margin: '0px',
              width: '100%',
            },
          }}
          onClose={() => setShowDetail(false)}
          open={showDetail}
          className="filter-dialog sm:!w-full xs:!w-full"
        >
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setShowDetail(false)} // Replace handleClose with your close function
            sx={{
              position: 'absolute',
              marginRight: 0,
            }}
            className="xs:text-xl -top-2 -right-2 sm:!text-3xl xs:-top-2 sm:top-1 xs:-right-2 sm:right-1"
          >
            <CancelOutlined fontSize="40px" />
          </IconButton>
          <img src={details} alt="" />
        </Dialog>
        <Footer />
      </div>
    </div>
  );
}
